<script>
import NewsForm from '@views/news/form';

export default {
  components: {
    NewsForm,
  },
  props: {
    value: {
      type: Boolean,
      default: null,
    },
    // eslint-disable-next-line
    loadedId: {
      default: null,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.showModal = true;
      } else {
        this.showModal = false;
      }
    },
  },
  methods: {
    submit(newsRecord) {
      this.$emit('submitted', newsRecord);
    },
  },
};
</script>

<template>
  <b-modal v-model="showModal" size="lg" hide-footer :title="loadedId ? $t('titles.edit_news_record') : $t('titles.create_news_record')" static @hidden="$emit('hidden')">
    <NewsForm v-if="showModal" :loaded-id="loadedId" @submitted="submit" />
  </b-modal>
</template>
